import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import extend from "extend";
import $ from "jquery";

export default class PurchaseController extends React.Component {
    constructor(props) {
        super(props);

        this.productStore = ComponentRegistry.getStore("ProductStore");
        this.basketStore = ComponentRegistry.getStore("BasketStore");
        this.state = {
            product: this.productStore.product,
            quantity: this.productStore.product.minimumPurchaseAmount,
            customizedProperties: {},
        };

        this.unsubscribe = this.productStore.listen(this.onProductChange.bind(this));
    }

    onProductChange(product) {
        if (product !== null && typeof product.url !== "undefined" && product.url !== null) {
            window.location = product.url;
        } else {
            this.setState({ product: product === null ? this.state.product : product });
        }
    }

    onCustomizedPropertiesChange(properties) {
        this.setState({ customizedProperties: properties === null ? this.state.customizedProperties : properties });
    }

    onPurchase() {
        const data = $.extend(true, {}, this.state, { productId: this.state.product.id });
        delete data.product;
        delete data.feedback;
        $.ajax(this.props.url, {
            method: "POST",
            data,
            success: (result) => {
                if (typeof result.basket !== "undefined" && this.store !== null) {
                    this.basketStore.load(result.basket);
                }
                this.setState({
                    feedback: { type: result.type, message: result.message },
                    quantity: result.type === "success" ? this.state.product.minimumPurchaseAmount : this.state.quantity,
                });
            },
        });
    }

    render() {
        const ProductPurchaseView = ComponentRegistry.get(this.props.view);

        return (
          <ProductPurchaseView
            {...this.props}
            {...this.state}
            onChange={values => this.setState(extend(true, { feedback: null }, values))}
            onPurchase={() => this.onPurchase()}
            onUpdateProduct={product => this.productStore.update(product)}
            onCustomizedPropertiesChange={ (properties) => { this.onCustomizedPropertiesChange(properties) } }
          />
        );
    }
}
PurchaseController.propTypes = {
    view: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

PurchaseController.defaultProps = {
    view: "ProductPurchaseViewsPurchaseView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Controllers/PurchaseController.jsx